<template>
    <div class="mainContent">
      <div class="item" v-for="item in list" @mouseover="handleMouseOver">
        <div class="secondTitle ">
          <span>{{ item.name }}</span>
          <div class="more" @click="$router.push({ path: '/news', query: { type: 'market' } })">
            {{ $store.state.language == "Chinese" ? "更多" : "More" }}
            <img src="@/assets/img/icon/list.png"/>
          </div>
        </div>
        <div class="newsList">
          <div class="pic">
            <div class="swiper-container-new">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="obj in item.data" >
                  <img class="zoomIn" :src="obj.imgUrl" />
                  <div class="intro">
                    <div class="introTitle">
                      {{ obj.title }}
                    </div>
                    <div class="time">{{ editDate(obj.gzhDate) }}</div>
                  </div>
                </div>
              </div>
              <!-- 如果需要分页器 -->
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div class="list ">
            <div v-for="(obj, j) in item.data" class="">
              <div @click="openNews(obj.detailUrl)" class="item " v-if="j<5">
              <div class="left ">
                <img src="@/assets/img/icon/list.png" />
                <span>{{ obj.title }}</span>
              </div>
              <span class="time">{{ editDate(obj.gzhDate) }}</span>
              <!-- @onReturn="() => { pageNum = 1; getList() }"  -->
            </div>
           
            <!-- <ListEdit style="z-index: 500000000;" v-if="$store.state.editStatus === 0" :data="obj" /> -->
            </div>
          </div>
         
        </div>
        
      </div>
    
    </div>
  </template>
  
  <script>
  import "swiper/dist/css/swiper.min.css";
  import "swiper/dist/js/swiper.min";
  import { getInformationList, getCommonDataList } from "@/api/news"
  export default {
    name: "NewsShow",
    data() {
      return {
        list: [],
        // 市场动态资讯
        listData: [],
        activeIndex: 0,
        // 公司活动资讯
        listData2: [],
        activeIndex2: 0,
      };
    },
    mounted() {
      this.getNews()
  
    },
    methods: {
      handleMouseOver(){
          console.log("handleMouseOver")
      },
      editDate(data) {
        if (data) {
          let arr = data.split(' ');
          return arr[0]
        } return ""
  
      },
      openNews(url) {
        if (url.indexOf('pdf')>-1) {
          let d = new Date()
          this.$router.push({ path: '/bdpdf', query: { name: url, t: d.getTime() } });
        } else {
          window.open(url);
        }
      },
      getNews() {
        this.list = [];
        getCommonDataList({ commonData: 'information', isRelease: this.$store.state.editStatus }).then(res => {
          // this.tableData = res.data;
          // this.active_index = res.data[0].keyValue
          // this.pageNum = 1;
          // this.getList();
          res.data.forEach((e, index) => {
            this.list.push({
              data: [],
              name: e.keyName
            });
            let params = {
              pageNum: 1,
              pageSize: 5,
              type: e.keyValue,
              isRelease: this.$store.state.editStatus
  
            }
            getInformationList(params).then(rss => {
  
              this.list[index].data = rss.data.list
              //加的数据
              // if (index == 0) {
              //   this.list[index].data.unshift({
              //     content: "关于园测信息科技股份有限公司拟首次公开发行股票接受辅导的公告",
              //     createTime: "2023-10-11 19:40:12",
              //     detailUrl: "pdf/gongao/fudaogonggao.pdf",
              //     id: "1712030909712678920",
              //     imgUrl: "pdf/gongao/gonggao.png",
              //     isRelease: 1,
              //     releaseTime: "2023-10-11 17:02:32",
              //     title: "关于园测信息科技股份有限公司拟首次公开发行股票接受辅导的公告",
              //     type: 2
  
              //   })
              // }
  
            })
          })
          setTimeout(() => {
            let _this = this;
            var mySwiper = new Swiper(".swiper-container-new", {
              direction: "vertical",
              loop: true,
              autoplay: 3000,
              observeParents: true,
              observer: true,
              // 如果需要分页器
              pagination: ".swiper-pagination",
              onSlideChangeEnd: function (swiper) {
                _this.activeIndex = swiper.realIndex;
              },
            });
            var mySwiper2 = new Swiper(".swiper-container-new2", {
              direction: "vertical",
              loop: true,
              autoplay: 4000,
              // 如果需要分页器
              pagination: ".swiper-pagination",
              onSlideChangeEnd: function (swiper) {
                _this.activeIndex2 = swiper.realIndex;
              },
            });
          }, 1000)
  
        })
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .swiper-container-new,
  .swiper-container-new2 {
    width: 523px;
    height: 294px;
  }
  
  .mainContent {
    margin: 0 160px;
    position: relative;
  }
  
  .item {
    .secondTitle {
      border-bottom: 3px solid #d7000f;
      display: flex;
      justify-content: space-between;
      text-align: left;
      line-height: 46px;
  
      span {
        background-color: #d7000f;
        display: block;
        // width: 120px;
        min-width: 100px;
        padding: 0 20px;
        text-align: center;
        font-weight: 600;
        color: #ffffff;
      }
  
      .more {
        text-align: right;
        cursor: pointer;
      }
    }
  
    .newsList {
      display: flex;
      margin: 5px 12px;
      margin-left: 0;
  
      .pic {
        width: 523px;
        height: 294px;
        margin-right: 20px;
        color: #fff;
        position: relative;
        overflow: hidden;
  
        img {
          width: 100%;
          height: 294px;
        }
  
        .intro {
          text-align: left;
          width: 100%;
          position: absolute;
          bottom: 0;
          height: 50px;
          background: #010c1b;
          opacity: 0.5;
          z-index: 99;
          padding: 5px 10px;
  
          .introTitle {
            width: 500px;
            word-break: keep-all;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
  
        .intro2 {
          bottom: 5px;
        }
  
        .time {
          text-align: right;
          padding: 5px 20px 0 0;
        }
      }
  
      .list {
        flex: 1;
        
        .item {
          // height: 23px;
          display: flex;
          justify-content: space-between;
  
          img {
            width: 12px;
            margin-right: 20px;
          }
  
          .left {
            width: 850px;
            text-align: left;
            // line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
  
          cursor: pointer;
          display: flex;
          border-bottom: 1px solid #eeeeee;
          padding: 14px 16px;
  
          .time {
            text-align: right;
          }
        }
      }
    }
  }
  </style>